import { useState } from 'react';
import { createPortal } from 'react-dom';
import { isIOS, isAndroid } from 'react-device-detect';
import { QRCodeSVG } from 'qrcode.react';
import appleSvg from '@/assets/app_stores/apple.svg';
import googlePlaySvg from '@/assets/app_stores/google_play.svg';

export const STORE_URLS = {
    ios: 'https://apps.apple.com/gr/app/padu/id1643700807',
    android: 'https://play.google.com/store/apps/details?id=com.padu.paduapp',
};

export const UNIVERSAL_URL = 'https://play.google.com/store/apps/details?id=com.padu.paduapp';

export function QRPopup({ onClose }: { onClose: () => void }) {
    return createPortal(
        <div
            className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm"
            onClick={onClose}
        >
            <div
                className="bg-white rounded-2xl p-8 flex flex-col items-center gap-4 shadow-2xl max-w-xs w-full mx-4"
                onClick={(e) => e.stopPropagation()}
            >
                <h3 className="text-black font-semibold text-lg text-center">
                    Σκάναρε για να κατεβάσεις το PADU
                </h3>
                <p className="text-gray-500 text-sm text-center">
                    Το κορυφαίο app επιβράβευσης στην Ελλάδα που σε ανταμείβει σε κάθε αγορά!
                </p>
                <QRCodeSVG
                    value={UNIVERSAL_URL}
                    size={180}
                    fgColor="#000000"
                    bgColor="#ffffff"
                    level="M"
                />

                <button
                    onClick={onClose}
                    className="text-sm text-gray-400 hover:text-gray-600 transition-colors cursor-pointer mt-1"
                >
                    Close
                </button>
            </div>
        </div>,
        document.body
    );
}

const DEFAULT_BUTTON_CLASS =
    'flex w-full items-center justify-center gap-2 bg-[#00d9d9] hover:bg-[#00b8b9] transition-colors text-black font-semibold px-6 py-3 rounded-full text-sm z-50';

export function AppDownloadButton({ className }: { className?: string } = {}) {
    const [showQR, setShowQR] = useState(false);

    // Explicitly check for mobile OS rather than relying on isMobile
    const isOnMobile = isIOS || isAndroid;
    const mobileUrl = isIOS ? STORE_URLS.ios : STORE_URLS.android;

    const buttonClass = className ?? DEFAULT_BUTTON_CLASS;

    if (isOnMobile) {
        return (
            <a
                href={mobileUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={buttonClass}
            >
                Κατέβασε την Εφαρμογή
            </a>
        );
    }

    return (
        <>
            <button
                type="button"
                onClick={() => setShowQR(true)}
                className={`${buttonClass} cursor-pointer`}
            >
                Κατέβασε την Εφαρμογή
            </button>
            {showQR && <QRPopup onClose={() => setShowQR(false)} />}
        </>
    );
}